import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import api from "../../../Services/api";
import "./cadastroGrupoModal.css";

const estadoInicial = {
  descricao: "",
  questaoModelo: 0,
  situacao: 1,
};

const CadastroGrupoModal = ({ open, grupo, onClose, onSaved }) => {
  const [saving, setSaving] = useState(false);
  const [form, setForm] = useState(estadoInicial);

  useEffect(() => {
    if (!open) return;
    if (grupo) {
      setForm({
        descricao: grupo.descricao || "",
        questaoModelo: Number(grupo.questaoModelo ?? 0),
        situacao: Number(grupo.situacao ?? 1),
      });
      return;
    }
    setForm(estadoInicial);
  }, [open, grupo]);

  if (!open) return null;

  const handleChange = (e) => {
    const { name, value } = e.target;
    const numericFields = ["questaoModelo", "situacao"];
    setForm((prev) => ({
      ...prev,
      [name]: numericFields.includes(name) ? Number(value) : value,
    }));
  };

  const salvar = async () => {
    if (!form.descricao.trim()) {
      await Swal.fire("Atenção", "Informe a descrição do grupo.", "warning");
      return;
    }

    try {
      setSaving(true);
      Swal.fire({
        title: "Salvando...",
        text: "Aguarde enquanto salvamos os dados.",
        allowOutsideClick: false,
        allowEscapeKey: false,
        didOpen: () => Swal.showLoading(),
      });

      if (grupo?.IDGrupoQuestao) {
        await api.put(`/chkgrupoquestao/${grupo.IDGrupoQuestao}`, form);
      } else {
        await api.post(`/chkgrupoquestao`, form);
      }

      Swal.close();
      await Swal.fire("Sucesso", "Grupo salvo com sucesso.", "success");
      onSaved?.();
      onClose?.();
    } catch (error) {
      console.error("Erro ao salvar grupo", error);
      Swal.fire(
        "Erro",
        error?.response?.data?.errors?.default || "Não foi possível salvar o grupo.",
        "error"
      );
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="cadGrupo-modal-overlay">
      <div className="cadGrupo-modal">
        <h5 className="cadGrupo-title">
          {grupo?.IDGrupoQuestao ? "Editar grupo de questões" : "Novo grupo de questões"}
        </h5>

        <div className="cadGrupo-form">
          <div className="cadGrupo-field">
            <label htmlFor="descricao">Descrição</label>
            <input
              id="descricao"
              name="descricao"
              type="text"
              maxLength={255}
              value={form.descricao}
              onChange={handleChange}
              disabled={saving}
              placeholder="Digite a descrição do grupo"
            />
          </div>

          <div className="cadGrupo-row">
            <div className="cadGrupo-field">
              <label htmlFor="questaoModelo">Grupo modelo</label>
              <select
                id="questaoModelo"
                name="questaoModelo"
                value={form.questaoModelo}
                onChange={handleChange}
                disabled={saving}
              >
                <option value={0}>Não</option>
                <option value={1}>Sim</option>
              </select>
            </div>

            <div className="cadGrupo-field">
              <label htmlFor="situacao">Situação</label>
              <select
                id="situacao"
                name="situacao"
                value={form.situacao}
                onChange={handleChange}
                disabled={saving}
              >
                <option value={1}>Ativo</option>
                <option value={0}>Inativo</option>
              </select>
            </div>
          </div>
        </div>

        <div className="cadGrupo-buttons">
          <button className="cadGrupo-btn-cancel" onClick={onClose} disabled={saving}>
            Cancelar
          </button>
          <button className="cadGrupo-btn-save" onClick={salvar} disabled={saving}>
            Salvar
          </button>
        </div>
      </div>
    </div>
  );
};

export default CadastroGrupoModal;
